import { createMandatoryContext } from '@change-corgi/core/react/context';

import type { SessionConfiguration } from 'src/shared/session';

export const {
	Context: SessionConfigurationContext,
	Provider: SessionConfigurationContextProvider,
	useContext: useSessionConfigurationContext,
} = createMandatoryContext<SessionConfiguration>(undefined, {
	name: 'SessionConfigurationContext',
});
